
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1176_2030)"}},[_c('path',{attrs:{"d":"M.667 11.667v.5h7v.166H.5V1.667h7.167v.166h-7v9.834zm10.162-6.555L10 4.386V5.917H5.333v2.166H10V9.614l.83-.726 1.728-1.512.43-.376-.43-.376-1.729-1.512zm-1.496.638h.5V4.019L13.241 7 9.833 9.981V8.25H5.167v-2.5h4.166z","fill":"#CFC4BE","stroke":"#CFC4BE"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1176_2030"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    